/**文件下载*/
export const API_GET_DOWNLOAD_FILE = {
  url: 'task/file/download',
  config: {
    method: 'get',
    host: 'TASKCENTER',
  },
};

/**获取任务中心websocket地址*/
export const API_GET_WEBSOCKET_ADDR = {
  url: 'message/selectWebSocketAddr',
  config: {
    method: 'get',
    host: 'MESSAGECENTER',
  },
};
export const API_GET_TASK = {
  url: 'task/task/my',
  config: {
    method: 'get',
    host: 'TASKCENTER',
  },
};
export const API_POST_TASK_CLEAR = {
  url: 'task/task/my/clear',
  config: {
    method: 'post',
    host: 'TASKCENTER',
  },
};
export const API_POST_MESSAGE_LIST = {
  url: 'message/selectMessageList',
  config: {
    method: 'post',
    host: 'MESSAGECENTER',
  },
};
export const API_PUT_TO_ALREADY_READ = {
  url: 'message/readZtMessage',
  config: {
    method: 'put',
    host: 'MESSAGECENTER',
  },
};
export const API_PUT_TO_ALREADY_DEL = {
  url: 'message/deleteZtMessage',
  config: {
    method: 'put',
    host: 'MESSAGECENTER',
  },
};
export const API_POST_RETRY_TASK = {
  url: 'task/task/retry/$id',
  config: {
    method: 'post',
    host: 'TASKCENTER',
  },
};

/**取消正在执行的任务*/
export const API_POST_CANCEL_TASK = {
  url: 'task/task/cancel',
  config: {
    method: 'post',
    host: 'TASKCENTER',
  },
};
export const API_POST_TASK_STAT = {
  url: 'task/task/running/stat',
  config: {
    method: 'post',
    host: 'TASKCENTER',
  },
};
